import React from 'react';
import {Switch ,FormControl,FormGroup,FormControlLabel,TextField,Typography,makeStyles,createStyles} from '@material-ui/core'
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const useStyles = makeStyles(theme =>
    createStyles({
      inputs: {
        fontSize: 14,
        minWidth:150
      },
      newPadding: {
        "& .MuiSelect-outlined": {
            padding: '8px 10px',
        }
      }
      
    })
);

function CheckBoxKundStatus(props) {
    const classes=useStyles()
    let Kundtyper=[
        {value:1,label:<IntlMessages id="Customer.Status1"/>},
        {value:2,label:<IntlMessages id="Customer.Status2"/>},
        {value:3,label:<IntlMessages id="Customer.Status3"/>},
        {value:4,label:<IntlMessages id="Customer.Status4"/>},
    ]  
    const ChangeMstate=(e)=>{
        console.log(e.target.checked)
        props.onChangeMstate(e.target.checked,{Meta:props.Meta,MetaN:props.MetaN,Value:-1,Checked:e.target.checked,Type:"Column",isSwitch:true})
    }
    const onChangeHandle = (e)=>{
        let Mstate = props.Mstate
        props.onChangeMstate(true,{Meta:props.Meta,MetaN:props.MetaN,Value:e.target.value,Checked:true,Type:"Column",isSwitch:true})
    }
    //Status
    const GetLabel=()=>{
        switch(props.Meta){
            case "Status": return props.intl.formatMessage({ id: 'Table.Status' });
            default: return props.Meta
        }
    }
    return (
        <>
            <FormControl component="fieldset" fullWidth>
              <FormGroup aria-label="position"  row>
              <FormControlLabel
              value={true}  
              style={{ width:"100%" }}      
              control={
              <Switch color="primary"
              disabled={props.disabled} 
              checked={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?false:true}
              onChange={ChangeMstate}
              size="small"
              />
              }
              label={<>
              {
                  <TextField
                  variant="outlined"
                  fullWidth                     
                  label={`${props.Meta}:`}
                  size="small"
                  name={`${props.MetaN}`}
                  select
                  style={{ width:"150px" }}
                  className={classes.newPadding}
                  disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
                  //value={props.Mstate.filter(item=>{return item.Meta === props.MetaN})[0].Value}
                  //value={0}
                  value={ isEmpty(Kundtyper)?0:isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?0:props.Mstate.filter(item=>{return item.MetaN === props.MetaN})[0].Value}
                  SelectProps={{native: true,}}
                  InputLabelProps={{shrink: true,}}
                  InputProps={{className: classes.inputs}}
                  onChange={onChangeHandle}
                  >
                  <option key={0} value={0} disabled><IntlMessages id="Choose"/></option>
                  <option key={-1} value={-1}><IntlMessages id="All"/></option>
                  {            
                    !isEmpty(Kundtyper)?
                    Kundtyper.map((option,index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    )):""}
              </TextField>  
              }
              
              </>}
              labelPlacement={"end"}
              />
              </FormGroup>
              
           </FormControl> 
        </>
    );
}


export default injectIntl(CheckBoxKundStatus);